import { WorkareaObject, FabricObjectOption } from "../types/FabricCustomType";

export const canvasOption = {
  preserveObjectStacking: true,
  width: window.screen.width,
  height: window.screen.height,
  selection: true,
  defaultCursor: "default",
  backgroundColor: "#fff",
  enteredScaling: true,
  centeredRotation: true,
};

export const keyEvent = {
  move: true,
  all: true,
  copy: true,
  paste: true,
  esc: true,
  del: true,
  clipboard: false,
  transaction: true,
  zoom: true,
  cut: true,
};

export const gridOption = {
  enabled: false,
  grid: 10,
  snapToGrid: false,
  lineColor: "#ebebeb",
  borderColor: "#cccccc",
};

export const workareaOption: Partial<WorkareaObject> = {
  width: 0,
  height: 0,
  workareaWidth: 0,
  workareaHeight: 0,
  lockScalingX: true,
  lockScalingY: true,
  scaleX: 1,
  scaleY: 1,
  backgroundColor: "#fff",
  hasBorders: false,
  hasControls: false,
  selectable: false,
  lockMovementX: true,
  lockMovementY: true,
  hoverCursor: "default",
  name: "",
  id: "workarea",
  type: "image",
  layout: "fixed", // fixed, responsive, fullscreen
  link: {},
  tooltip: {
    enabled: false,
  },
  isElement: false,
  superType: "workarea",
};

export const objectOption: Partial<FabricObjectOption> = {
  rotation: 0,
  centeredRotation: true,
  strokeUniform: true,
};

export const guidelineOption = {
  enabled: true,
};

export const activeSelectionOption = {
  hasControls: true,
  _controlsVisibility: {
    bl: false,
    br: false,
    mb: false,
    ml: false,
    mr: false,
    mt: false,
    mtr: true,
    tl: false,
    tr: false
  },
  subTargetCheck: true,
  hasBorders: false
};

export const propertiesToInclude = [
  "id",
  "name",
  "superType",
  "locked",
  "editable",
  "subTargetCheck",
  "hasControls",
  "visible",
  "seatsQuantity",
  "maxSeatsQuantity",
  "rowSize",
  "seatsSpacing",
  "distanceBetweenX",
  "distanceBetweenY",
  "category",
  "seat",
  "section",
  "row",
  "side",
  "label",
  "displayedLabel",
  "restrictedView",
  "companion",
  "accesible",
  "value",
  "isLabeled",
  "seatsCurve",
  "curveMode",
  "angleHelp",
  "angleType",
  "visibleIcon",
  "visibleText",
  "_controlsVisibility",
  "scaled",
  "originHeight",
  "originWidth",
  "rotated",
  "perPixelTargetFind",
  "checkFontWeight",
  "checkFontStyle",
  "strokeWidthShape",
  "lockMovementX",
  "lockMovementY",
  "selectable",
  "zoneID",
  "channel",
  "maxSeats",
  "maxEmptySpaces",
  "emptySpaces",
  "tableLabeling",
  "seatLabeling",
  "selectionType",
  "rowLabel",
  "sectionLabel",
  "tableLabel"
];